import { Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import Looks5Icon from "@mui/icons-material/Looks5";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import { useIsDarkMode } from "../../../theme/ThemeContext";
import {
  PageHeader,
  PageShell,
  SectionHeader,
} from "../../../components/UI/Page";

const ScheduleOrders = () => {
  const isDark = useIsDarkMode();

  const getOrders = (setter) => {
    return fetch(`/api/orders`)
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson);
        setter(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  /**
   * Moves an item from one list to another list.
   */
  const move = (
    source,
    destination,
    droppableSource,
    droppableDestination,
    dropBranch
  ) => {
    var sourceCopy = source;
    var destinationCopy = destination;

    // console.log(dropBranch);
    // console.log(destinationCopy);

    destinationCopy.splice(
      destinationCopy.index,
      0,
      sourceCopy[droppableSource.index]
    );

    sourceCopy.splice(droppableSource.index, 1);

    setOrders(sourceCopy);
    //setBranch({ ...branch, dropBranch: destinationCopy });
  };

  const grid = 8;

  /* Surface colors for the drag-and-drop panels. These are inline styles
     react-beautiful-dnd needs, so they use the theme tokens from index.css
     (CSS variables follow classic/glass × light/dark) instead of a Tailwind
     `dark:` variant. Every background is paired with a text color so the
     order cards can't end up light-on-light or dark-on-dark. A card being
     dragged floats over the page, so it uses the near-opaque popover
     surface rather than a translucent one. */
  const surface = "var(--app-card-bg)";
  const inset = "var(--app-surface-bg)";
  const dropActive = "rgba(14, 165, 233, 0.16)";
  const dragActive = "var(--app-popover-bg)";
  const disabled = "var(--app-hover)";
  const bodyText = "var(--app-text)";

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 ${grid}px 0 0`,

    // change background colour if dragging
    background: isDragging ? dragActive : surface,
    color: bodyText,
    borderRadius: 14,
    boxShadow: isDragging
      ? "var(--app-popover-shadow)"
      : "var(--app-card-shadow)",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver, includeskey, closestBranches) => {
    if (includeskey) {
      return {
        background: isDraggingOver ? dropActive : inset,
        color: bodyText,
        borderWidth: "2px",
        borderStyle: "dashed",
        padding: grid,
        borderRadius: "16px",
        width: isDraggingOver ? "33%" : "25%",
        height: isDraggingOver ? "33%" : "25%",
        borderColor: isDark ? "#34d399" : "#059669",
      };
    } else if (closestBranches.length === 0) {
      return {
        background: isDraggingOver ? dropActive : inset,
        color: bodyText,
        padding: grid,
        borderRadius: "16px",
        width: isDraggingOver ? "33%" : "25%",
        height: isDraggingOver ? "33%" : "25%",
      };
    } else {
      return {
        background: disabled,
        color: "var(--app-text-muted)",
        padding: grid,
        borderRadius: "16px",
        width: "25%",
        height: "25%",
      };
    }
  };

  const getOrderListStyle = (isDraggingOver) => {
    return {
      background: isDraggingOver ? dropActive : inset,
      color: bodyText,
      display: "flex",
      padding: grid,
      overflow: "auto",
      borderRadius: "16px",
    };
  };

  const [orders, setOrders] = useState([]);
  const [closestBranches, setClosest] = useState([]);
  const [branch, setBranch] = useState({
    edgerton: [],
    kendallville: [],
    shipshewana: [],
    adrian: [],
    cromwell: [],
    fort_wayne: [],
    schoolcraft: [],
    elkhart: [],
    delton: [],
    granger: [],
    mishawaka: [],
    roseland: [],
    eau_claire: [],
    coloma: [],
    three_oaks: [],
    laporte: [],
  });

  const [modal, setModal] = useState(false);

  useEffect(() => {
    getOrders(setOrders);
  }, []);

  // Rank badge colors sit on the branch panel surface, so they brighten in dark.
  const rankGreen = isDark ? "#34d399" : "green";
  const rankAmber = isDark ? "#fbbf24" : "orange";
  const rankRed = isDark ? "#f87171" : "red";

  const displayBranchRank = (rank) => {
    switch (rank) {
      case 0:
        return <LooksOneIcon style={{ color: rankGreen }} />;
        break;
      case 1:
        return <LooksTwoIcon style={{ color: rankGreen }} />;
        break;
      case 2:
        return <Looks3Icon style={{ color: rankAmber }} />;
        break;
      case 3:
        return <Looks4Icon style={{ color: rankAmber }} />;
        break;
      case 4:
        return <Looks5Icon style={{ color: rankRed }} />;
        break;
      case -1:
        break;

      default:
        break;
    }
  };

  const getList = (id) => {
    switch (id) {
      case "edgerton":
        return branch.edgerton;
        break;
      case "kendallville":
        return branch.kendallville;
        break;
      case "shipshewana":
        return branch.shipshewana;
        break;
      case "adrian":
        return branch.adrian;
        break;
      case "cromwell":
        return branch.cromwell;
        break;
      case "fort_wayne":
        return branch.fort_wayne;
        break;
      case "schoolcraft":
        return branch.schoolcraft;
        break;
      case "elkhart":
        return branch.elkhart;
        break;
      case "delton":
        return branch.delton;
        break;
      case "granger":
        return branch.granger;
        break;
      case "mishawaka":
        return branch.mishawaka;
        break;
      case "roseland":
        return branch.roseland;
        break;
      case "eau_claire":
        return branch.eau_claire;
        break;
      case "coloma":
        return branch.coloma;
        break;
      case "three_oaks":
        return branch.three_oaks;
        break;
      case "laporte":
        return branch.laporte;
        break;
      case "orders":
        return orders;

      default:
        break;
    }
  };

  const getClosest5Branches = (id) => {
    var closestBranches = [];
    Object.entries(orders).map((key, value) => {
      if (key[1]._id === id) {
        Object.entries(key[1].distance_from_branch).map((key, value) => {
          if (closestBranches.length < 5) {
            closestBranches.push(key[0]);
          }
        });
      }
    });

    setClosest(closestBranches);
  };

  const onDragStart = (result) => {
    getClosest5Branches(result.draggableId);
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      //reorder "Orders" list
    } else {
      move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination,
        destination.droppableId
      );
    }
    setClosest([]);
  };

  return (
    <PageShell size="full">
      <PageHeader
        icon={EventNoteOutlinedIcon}
        tone="indigo"
        eyebrow="Orders"
        title="Schedule Orders"
        description="Drag an order onto one of its five closest branches — the ranked branches light up while you drag."
      />
      <SectionHeader title="My Orders" />
      {orders && (
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
          <div className="mb-8">
            <Droppable droppableId="orders" direction="horizontal">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  style={getOrderListStyle(snapshot.isDraggingOver)}
                  className="flex border app-divider"
                >
                  {orders.map((item, index) => {
                    return (
                      <Draggable
                        key={item._id}
                        draggableId={item._id}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            className="flex flex-col border app-divider"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <div className="w-64 space-y-1 text-sm">
                              <p className="font-semibold tabular-nums">
                                Order #{item.orderNumber}
                              </p>
                              <p className="app-muted">{item.address}</p>
                              <p className="text-xs">
                                Closest Branch:{" "}
                                {Object.keys(item.distance_from_branch)[0]}
                              </p>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
          <SectionHeader title="Branches" />

          <div className="app-card flex overflow-x-auto rounded-2xl border p-4">
            {Object.entries(branch).map((key, value) => {
              var bRank = closestBranches.findIndex(function (item) {
                return item.indexOf(key[0]) !== -1;
              });
              return (
                <Droppable
                  isDropDisabled={
                    closestBranches.includes(key[0]) ? false : true
                  }
                  visible={false}
                  droppableId={key[0]}
                  key={value}
                  index={value}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(
                        snapshot.isDraggingOver,
                        closestBranches.includes(key[0]),
                        closestBranches
                      )}
                      className="m-2 flex"
                    >
                      <div className="flex flex-col items-center">
                        <div className="flex flex-col">
                          <div className="flex items-center justify-center gap-1">
                            <p className="app-eyebrow w-7/8 !text-[color:inherit]">
                              {key[0].toUpperCase()}
                            </p>
                            {displayBranchRank(bRank)}
                          </div>

                          {key[1].map((item, index) => (
                            <div className="app-card m-2 flex w-64 flex-col rounded-xl border p-3 text-sm">
                              <p className="font-semibold tabular-nums">
                                Order #{item.orderNumber}
                              </p>
                              <p className="app-muted">{item.address}</p>
                              <p className="text-xs">
                                Closest Branch:{" "}
                                {Object.keys(item.distance_from_branch)[0]}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </Droppable>
              );
            })}
          </div>
        </DragDropContext>
      )}
    </PageShell>
  );
};

export default ScheduleOrders;
